/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnChanges, type SimpleChanges, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { LazyloadService, UNPLACEHOLDER } from '@dm/core';

import { AntivirusStrService } from '../../antivirus-str.service';
import { FilePathDetailComponent } from './file-path-detail/file-path-detail.component';

export enum FilePathRenderEntryE {
    TABLE = 'table',
    DETAIL = 'detail',
    SELECTION_PREVIEW = 'selection_preview',
    TASK_ONDEMAND_PREVIEW = 'task_ondemand_preview',
    TASK_ONACCESS_PREVIEW = 'task_onaccess_preview'
}

@Component({
    selector: 'app-file-path-table-render',
    templateUrl: './file-path-table-render.component.html',
    styleUrls: ['./file-path-table-render.component.scss'],
})
export class FilePathTableRenderComponent implements OnChanges {
    private _mesContainer: ElementRef = null;

    @Input() filePath: string;
    @Input() entry: FilePathRenderEntryE;
    @Input() maxWidth: string;
    @ViewChild('mesContainer') get mesContainer(): ElementRef {
        return this._mesContainer;
    }
    /**
     * 监听不扫描路径的变化
     */
    set mesContainer(value: ElementRef) {
        this._mesContainer = value;
        this.onFilePathViewLoaded();
    }

    UNPLACEHOLDER = UNPLACEHOLDER;
    FilePathRenderEntryE = FilePathRenderEntryE;
    isFilePathEmpty = true;
    showAll = false;
    isMoreBtnShow = false;
    toggleBtnLabel = this.str.i18n.moreLabel;
    filePathArr: string[] = [];
    tipMaxLenth = 1800;

    constructor(
        private str: AntivirusStrService,
        private lazyloadService: LazyloadService,
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        // 初始化是否只显示部分
        this.showAll = false;
        this.toggleBtnLabel = this.str.i18n.moreLabel;

        if (changes.filePath && changes.filePath.currentValue && changes.filePath.currentValue !== UNPLACEHOLDER) {
            this.isFilePathEmpty = false;
            this.filePathArr = this.str.excludeFilePathMesRender(this.filePath);
        } else {
            this.isFilePathEmpty = true;
            this.filePathArr = [];
        }
    }

    /**
     * 显示部分/全部转换事件
     */
    toggleFilePathView(): void {
        this.showAll = !this.showAll;
        this.toggleBtnLabel = this.showAll ? this.str.i18n.foldLabel : this.str.i18n.moreLabel;
    }

    /**
     * 根据所选策略判断是否需要展示全部
     */
    onFilePathViewLoaded(): void {
        if (this.mesContainer && this.mesContainer.nativeElement &&
            this.mesContainer.nativeElement.scrollHeight > 90) {
            this.isMoreBtnShow = true;
        } else {
            this.isMoreBtnShow = false;
        }
    }

    /**
     * 不扫描路径有变化触发的事件
     */
    onResize(): void {
        this.onFilePathViewLoaded();
    }

    /**
     * 显示不扫描路径详情
     */
    showDetail(filePath: string): void {
        if (filePath.length > this.tipMaxLenth) {
            this.lazyloadService.appendComponent(FilePathDetailComponent, {
                filePath,
            });
        }
    }

    overTipMaxLengthRender = (filePath: string): string => filePath.length > this.tipMaxLenth ?
        filePath.substring(0, this.tipMaxLenth).concat(this.str.i18n.viewAll) :
        filePath;
}
